import { useEffect, useState } from 'react';

let pending = null;

const load = () => {
  if (!pending) {
    pending = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/etsy/reviews?limit=8`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => (d && d.source === 'etsy' ? d : null))
      .catch(() => null);
  }
  return pending;
};

export const useEtsyLive = () => {
  const [live, setLive] = useState(null);
  useEffect(() => {
    let cancelled = false;
    load().then((d) => { if (!cancelled) setLive(d); });
    return () => { cancelled = true; };
  }, []);
  return live;
};

export default useEtsyLive;
